export default "__VITE_ASSET__ee67758b__"